import React from 'react'

const Spinner = () => {
    return (
        <div class="spinner-border text-success container" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    )
}

export default Spinner
